export default __webpack_public_path__ + "static/map-02-0b9b17ce9ada275062aa8cf3b5eb9d0d.jpg";